// MedicalConditionsTable.jsx
import React from "react";
import { TextField, Button } from "@mui/material";

const MedicalConditionsTable = ({
  medicalConditions,
  setMedicalConditions,
}) => {
  const handleMedicalConditionChange = (index, field, value) => {
    setMedicalConditions((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const addMedicalConditionRow = () => {
    setMedicalConditions((prev) => [
      ...prev,
      { condition: "", medication: "", dose: "" },
    ]);
  };

  const removeMedicalConditionRow = (index) => {
    setMedicalConditions((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div style={{ marginBottom: "10px" }}>
      {/* <Typography variant="h6" gutterBottom>
        Medical Conditions and Medications
      </Typography> */}
      <div
        style={{
          border: "1px solid lightgrey",
          borderRadius: "5px",
          paddingLeft: "10px",
          marginTop: "10px",
          marginRight: "10px",
          paddingTop: "5px",
          marginBottom: "10px",
        }}
      >
        <div style={{ marginTop: "10px", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={styles.header}>Medical Condition(s)</th>
                <th style={styles.header}>Medication(s)</th>
                <th style={styles.header}>Dose</th>
                <th style={styles.header}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {medicalConditions.map((entry, index) => (
                <tr key={index}>
                  <td style={styles.cell}>
                    <TextField
                      value={entry.condition}
                      onChange={(e) =>
                        handleMedicalConditionChange(
                          index,
                          "condition",
                          e.target.value
                        )
                      }
                      fullWidth
                      placeholder="Medical Condition"
                    />
                  </td>
                  <td style={styles.cell}>
                    <TextField
                      value={entry.medication}
                      onChange={(e) =>
                        handleMedicalConditionChange(
                          index,
                          "medication",
                          e.target.value
                        )
                      }
                      fullWidth
                      placeholder="Medication"
                    />
                  </td>
                  <td style={styles.cell}>
                    <TextField
                      value={entry.dose}
                      onChange={(e) =>
                        handleMedicalConditionChange(
                          index,
                          "dose",
                          e.target.value
                        )
                      }
                      fullWidth
                      placeholder="Dose"
                    />
                  </td>
                  <td style={styles.cell}>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => removeMedicalConditionRow(index)}
                    >
                      Remove
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ marginTop: "10px" }}>
        <Button variant="outlined" onClick={addMedicalConditionRow}>
          Add Row
        </Button>
      </div>
    </div>
  );
};

const styles = {
  header: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#f0f0f0",
  },
  cell: {
    border: "1px solid lightgray",
    padding: "10px",
    textAlign: "left",
  },
};

export default MedicalConditionsTable;
